import { render, staticRenderFns } from "./CharactersSplashclassImprovements.vue?vue&type=template&id=de499b66&lang=pug&"
import script from "./CharactersSplashclassImprovements.vue?vue&type=script&lang=ts&"
export * from "./CharactersSplashclassImprovements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports